import React from "react";
import { SiXero, SiQuickbooks } from "react-icons/si";
import { Landmark, FileBox, Receipt, CreditCard } from "lucide-react";

const logos = [
  { name: "Xero", el: <SiXero className="h-7 w-auto" /> },
  { name: "QuickBooks", el: <SiQuickbooks className="h-7 w-auto" /> },
  {
    name: "FreeAgent",
    el: <span className="font-serif-display text-xl">FreeAgent</span>,
  },
  {
    name: "Dext",
    el: (
      <span className="inline-flex items-center gap-2">
        <FileBox className="h-5 w-5" />
        <span className="font-serif-display text-xl">Dext</span>
      </span>
    ),
  },
  {
    name: "GoCardless",
    el: (
      <span className="inline-flex items-center gap-2">
        <CreditCard className="h-5 w-5" />
        <span className="font-serif-display text-xl">GoCardless</span>
      </span>
    ),
  },
  {
    name: "HMRC MTD",
    el: (
      <span className="inline-flex items-center gap-2">
        <Landmark className="h-5 w-5" />
        <span className="font-serif-display text-xl">HMRC MTD</span>
      </span>
    ),
  },
];

export const SoftwareLogos = () => (
  <section
    data-testid="software-logos-section"
    className="bg-[#EAF4DD] border-y border-[#2A3430]/10 py-16 md:py-20"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center max-w-2xl mx-auto">
        <p className="text-xs uppercase tracking-[0.2em] text-[#C57A5A] font-medium inline-flex items-center gap-2">
          <Receipt className="h-3.5 w-3.5" /> Integrations
        </p>
        <h2 className="font-serif-display mt-3 text-2xl sm:text-3xl md:text-4xl text-[#2A3430]">
          We work with tools you already know.
        </h2>
      </div>

      <div className="mt-12 flex flex-wrap items-center justify-center gap-3 md:gap-4">
        {logos.map((l) => (
          <span
            key={l.name}
            data-testid={`software-pill-${l.name.toLowerCase().replace(/\s+/g, "-")}`}
            title={l.name}
            className="inline-flex items-center justify-center px-5 py-3.5 rounded-full bg-white border border-[#2A3430]/10 text-[#2A3430]/70 hover:text-[#2A3430] hover:border-[#C57A5A]/50 hover:-translate-y-0.5 hover:shadow-md transition-all duration-300"
          >
            {l.el}
          </span>
        ))}
      </div>
    </div>
  </section>
);

export default SoftwareLogos;
